import { Link } from "react-router-dom";
import { eur } from "../../lib/impresa";

export const FONTI = {
  impresa: { label: "Impresa", chip: "bg-amber-50 text-amber-900 border-amber-500 hover:bg-amber-100", legenda: "bg-amber-50 border-l-2 border-amber-500", attivo: "bg-amber-100 text-amber-900 border border-amber-300", dot: "bg-amber-500" },
  personali: { label: "Personali", chip: "bg-violet-50 text-violet-900 border-violet-500 hover:bg-violet-100", legenda: "bg-violet-50 border-l-2 border-violet-500", attivo: "bg-violet-100 text-violet-900 border border-violet-300", dot: "bg-violet-500" },
};
const GRUPPO_IMPRESA = { f24: "F24", pagamenti: "Da pagare", incassi: "Da incassare", operai: "Operai", patrimonio: "Mezzo", certificazioni: "Certif." };
const key = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** Normalizza scadenze impresa e personali in voci calendario raggruppate per giorno (YYYY-MM-DD). */
const perGiorno = ({ scadImpresa = [], scadPers = [] }) => {
  const m = new Map();
  const add = (data, voce) => { if (!data) return; const k = String(data).slice(0, 10); if (!m.has(k)) m.set(k, []); m.get(k).push(voce); };
  scadImpresa.forEach((v, i) => add(v.data, { id: `imp-${i}`, fonte: "impresa", titolo: v.titolo, sotto: [GRUPPO_IMPRESA[v.gruppo] || "", v.importo > 0 ? eur(v.importo) : ""].filter(Boolean).join(" · "), link: v.movimento_id ? "/impresa/scadenzario" : "/impresa/operai", scaduto: v.scaduto }));
  scadPers.forEach((s) => add(s.scadenza, { id: `pers-${s.id}`, fonte: "personali", titolo: s.descrizione || s.tipo_label || s.tipo, sotto: s.tipo_label || "", link: "/scadenze-professionali", scaduto: s.stato === "scaduta" }));
  return m;
};

/** Chip delle scadenze extra (impresa/personali) nel calendario; `compatto` = solo pallini (intestazione settimana). */
export function ScadenzeExtra({ items, compatto = false }) {
  if (!items?.length) return null;
  if (compatto) {
    return (
      <div className="flex justify-center gap-0.5 mt-0.5" title={items.map((x) => x.titolo).join("\n")} data-testid="cal-extra-dots">
        {items.slice(0, 5).map((x) => <span key={x.id} className={`inline-block w-1.5 h-1.5 rounded-full ${FONTI[x.fonte].dot}`} />)}
      </div>
    );
  }
  return items.map((x) => (
    <Link key={x.id} to={x.link} onClick={(e) => e.stopPropagation()} title={`${x.titolo}${x.sotto ? ` — ${x.sotto}` : ""}`}
      className={`w-full text-left rounded px-1.5 py-0.5 text-[10px] truncate border-l-2 block ${FONTI[x.fonte].chip} ${x.scaduto ? "font-semibold" : ""}`} data-testid={`cal-extra-${x.id}`}>
      {x.titolo}{x.sotto ? <span className="opacity-70"> · {x.sotto}</span> : null}
    </Link>
  ));
}
ScadenzeExtra.perGiorno = perGiorno;
ScadenzeExtra.key = key;

/** Interruttori Impresa / Personali accanto ai filtri Appuntamenti / Incarichi. */
export function FiltriFonti({ showImp, setShowImp, showPers, setShowPers }) {
  const Btn = ({ on, set, fonte, testId }) => (
    <button type="button" onClick={() => set((v) => !v)} className={`px-2 py-1 rounded text-[11px] font-medium inline-flex items-center gap-1.5 ${on ? FONTI[fonte].attivo : "text-slate-400 hover:text-slate-700"}`} data-testid={testId} title={`Mostra/nascondi scadenze ${FONTI[fonte].label.toLowerCase()}`}>
      <span className={`w-2 h-2 rounded-sm ${on ? FONTI[fonte].dot : "bg-slate-300"}`} />{FONTI[fonte].label}
    </button>
  );
  return <><Btn on={showImp} set={setShowImp} fonte="impresa" testId="filter-impresa" /><Btn on={showPers} set={setShowPers} fonte="personali" testId="filter-personali" /></>;
}
